import React from 'react'
import WrapperByRole, { WrapperByRoleProps } from '../Wrapper/WrapperByRole'

const StaffWrapper: React.FC<WrapperByRoleProps> = (props) =>
  <WrapperByRole role='staff' {...props} />

export default StaffWrapper